import { getRequestHeaders, handleRes, logError } from "utils";
import { EntityTypes, PermitType } from "types";

interface GetEntityPermitTypesParams {
  tenantID: number | string | undefined;
  entityType:
    | EntityTypes.Property
    | EntityTypes.PropertyGroup
    | EntityTypes.None;
  entityID: number | string | undefined;
}
export const getEntityPermitTypes = ({
  tenantID,
  entityType,
  entityID,
}: GetEntityPermitTypesParams): Promise<PermitType[]> => {
  return fetch(
    `${window.PERMIT_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/permitType`,
    {
      method: "GET",
      ...getRequestHeaders(),
    },
  )
    .then((res) => handleRes<PermitType[]>(res, 200))
    .catch((e) => {
      logError(e);
      return [];
    });
};

interface UpdatePermitTypeParams {
  tenantID: number | string | undefined;
  entityType:
    | EntityTypes.Property
    | EntityTypes.PropertyGroup
    | EntityTypes.None;
  entityID: number | string | undefined;
  permitTypeID: number | string | undefined;
  body: string; // PermitType[] as Json string
}
export const updatePermitType = async ({
  tenantID,
  entityType,
  entityID,
  permitTypeID,
  body,
}: UpdatePermitTypeParams): Promise<Response> => {
  let idToUse = permitTypeID;
  if (!permitTypeID) {
    const permitTypeBody = JSON.parse(body);
    idToUse = permitTypeBody.id;
  }
  return await fetch(
    `${window.PERMIT_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/permitType/${idToUse}`,
    {
      method: "PUT",
      ...getRequestHeaders(),
      body,
    },
  );
};

interface DisablePermitTypeParams {
  tenantID: number | string | undefined;
  entityType:
    | EntityTypes.Property
    | EntityTypes.PropertyGroup
    | EntityTypes.None;
  entityID: number | string | undefined;
  permitTypeID: number | string | undefined;
}
export const disablePermitType = async ({
  tenantID,
  entityType,
  entityID,
  permitTypeID,
}: DisablePermitTypeParams): Promise<Response> => {
  return await fetch(
    `${window.PERMIT_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/permitType/${permitTypeID}`,
    {
      method: "DELETE",
      ...getRequestHeaders(),
    },
  );
};

interface CreatePermitTypeParams {
  tenantID: number | string | undefined;
  entityType:
    | EntityTypes.Property
    | EntityTypes.PropertyGroup
    | EntityTypes.None;
  entityID: number | string | undefined;
  body: string; // PermitType as Json string
}
export const createPermitType = async ({
  tenantID,
  entityType,
  entityID,
  body,
}: CreatePermitTypeParams): Promise<Response> => {
  return await fetch(
    `${window.PERMIT_BASE_URL}/tenant/${tenantID}/${entityType}/${entityID}/permitType`,
    {
      method: "POST",
      ...getRequestHeaders(),
      body,
    },
  );
};
